import { render, staticRenderFns } from "./VideoDirectAddSuper.vue?vue&type=template&id=22eb9c04&scoped=true"
import script from "./VideoDirectAddSuper.vue?vue&type=script&lang=js"
export * from "./VideoDirectAddSuper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22eb9c04",
  null
  
)

export default component.exports